import styles from "./Third.module.css";
import School from "../components/education/School";

function Third({ educationRef }) {
  const universities = [
    {
      id: "0",
      degree: "PhD Student (Bac+9)",
      school:
        "Mohammed VI Polytechnic University, Ben Guerir",
      faculty: "Natural Language Processing, College of Computing",
      period: "10/2023 - 09/2027",
    },
    {
      id: "1",
      degree: "Engineering student (Bac+5)",
      school:
        "National Institute of Posts and Telecommunications (INPT), Rabat",
      faculty: "Advanced software engineering for digital services (ASEDS)",
      period: "09/2020 - 07/2023",
    },
    {
      id: "2",
      degree: "Preparatory classes (Bac+2)",
      school: "Acharif Al Idrissi High School,Taza",
      faculty: "Mathematics & Physics & Engineer Sciences",
      period: "09/2018 - 07/2020",
    },
    {
      id: "3",
      degree: "Scientific baccalaureate",
      school: "Ibn Khaldoune High School, Karia Ba Mohamed",
      faculty: "Mathematics French Option (FO)",
      period: "2018",
    },
  ];

  return (
    <div ref={educationRef} className={styles.thirdsection}>
      <h1 className={styles.title}>02. Education</h1>
      <div className={styles.schools}>
        {universities.map((element) => (
          <School key={element.id} university={element} />
        ))}
      </div>
    </div>
  );
}
export default Third;
